// used by balance tracking apps to persist data client-side
export const CACHE_KEYS = {
  CEFI_ACCOUNTS: "cefi-accounts",
  CEFI_USER_ID: "cefi-userId",
};
